var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer",on:{"click":_vm.toggle}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],staticClass:"inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }